import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSelectedIndicator = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 40,
	viewBox: "0 0 20 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.5208 19.0778C15.8212 19.6559 15.8212 20.3441 15.5208 20.9222L8.52471 34.3862C7.55938 36.244 4.75 35.5576 4.75 33.464L4.75 6.53597C4.75 4.44235 7.55938 3.75601 8.52471 5.6138L15.5208 19.0778Z",
		fill: "#377DC3"
	})
});
export default SvgSelectedIndicator;
